// SessionStorage / localStorage key names for auth flow coordination.
export const AUTH_SESSION_KEYS = {
  ACCOUNT_EXPIRED: "accountExpired",
  CALLBACK_FAILURE_COUNT: "callbackFailureCount",
  DESIRED_NAV: "desiredNav",
  DOMAIN_HINT: "domainHint",
  FEDERATION_REDIRECT_IN_PROGRESS: "federationRedirectInProgress",
  FEDERATION_AUTO_REDIRECT_GUARD: "federationAutoRedirectGuard",
  FORCE_ACCOUNT_SELECTION: "forceAccountSelection",
  LOGGED_OUT_MESSAGE: "loggedOutMessage",
  POST_CALLBACK_AUTH_PENDING: "postCallbackAuthPending",
  POST_CALLBACK_AUTH_GRACE_STARTED_AT: "postCallbackAuthGraceStartedAt",
  SKIP_AUTO_SESSION_CHECK_ONCE: "skipAutoSessionCheckOnce",
};

// Query-string keys and values used in logout/redirect URLs.
export const AUTH_QUERY_KEYS = {
  DOMAIN_HINT: "domain_hint",
  SOURCE: "source",
  STATUS: "status",
  TOKEN_REVOKED: "tokenRevoked",
};

export const AUTH_QUERY_VALUES = {
  AUTO: "auto",
  IDLE: "idle",
  TRUE: "true",
};
